import { Draft, current } from 'immer';
import { CellHistory, CellPosition, Sheet } from '../../types';
import { CellInput } from '../../types/commands/sheetCommands/sheetCommands';
import { SheetManagementSet } from '../../types/sheet/draft';
import { replaceSheetNamesWithId } from '../address/formulaValidation';
import {
  deleteCellResultDepFormat,
  getCell,
  saveCellValueWithHistory,
} from './cellCRUD';
import moment from 'moment';
import {
  ProcessReferencesConfigs,
  processReferences,
} from '../references/processReferences';
import {
  cellInputCommand,
} from '../commands/generate/generateSheetCommands';

export async function onCellInput(
  set: SheetManagementSet,
  sheet: Draft<Sheet>,
  command: CellInput,
  configs?: Partial<ProcessReferencesConfigs>
) {
  const sheetId = sheet.id;
  const { position, value } = command;
  const sheetIdToName = set.staticEntityIdToNameMap.sheetsIdToName;
  const input = replaceSheetNamesWithId(value, sheetIdToName);

  const result = handleCellText(set.userId, sheet, position, input);

  // console.log('result', result, result?.oldCellValue);

  if (result !== undefined) {
    await processReferences(set, sheet, position, result.newCell, configs);

    cellInputCommand(set, sheetId, command, result.oldCellValue);
  }
}

function handleCellText(
  userId: string,
  sheet: Draft<Sheet>,
  position: CellPosition,
  text: string
) {
  const value = parseCellText(text);
  const { cells } = sheet;

  const oldCell = getCell(cells, position);
  const oldCellValue = oldCell?.v;

  if (oldCellValue === value) return undefined;

  deleteCellResultDepFormat(cells, position);

  const newHistory: CellHistory = {
    v: text,
    u: userId,
    t: moment().unix(),
  };

  const newCell = saveCellValueWithHistory(cells, position, value, newHistory);

  return {
    oldCellValue,
    newCell,
  };
}

const parseCellText = (input: string) => {
  const trimmedInput = input.trim();

  if (trimmedInput.length === 0) {
    return '';
  }

  const numericValue = Number(trimmedInput);

  if (isNaN(numericValue)) {
    // if (trimmedInput.toLowerCase() === 'true') return true;
    // else if (trimmedInput.toLowerCase() === 'false') return false;

    return trimmedInput;
  }

  return numericValue;
};
